<template>
  <div>
    <div style="height: 40px;width: 100%">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
      <div class="add-open-btn" @click="addOpen()">
        <strong>+</strong>
      </div>
    </div>
    <!--通讯录设置-->
    <div v-if="indexActive === 0">
      <el-table
        :data="showTable1"
        size="mini"
        border
        style="width: 100%"
        highlight-current-row
        ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话"
          min-width="85">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="短号"
          min-width="85">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="90"  class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <i class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517"></i>
            <i class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--FM频率设置-->
    <div v-if="indexActive === 1">
      <fm-info ref="fm" :fmObj="FMObj"></fm-info>
    </div>
    <el-dialog
      width="600px"
      title="新增通讯录"
      :visible.sync="addEditShow1"
      v-if="addEditShow1"
      append-to-body
      center>
      <add-edit-list-phone :listObj="listObj" v-model="addEditShow1"></add-edit-list-phone>
    </el-dialog>
    <el-dialog
      width="600px"
      title="设置电台FM"
      :visible.sync="addEditShow2"
      v-if="addEditShow2"
      append-to-body
      center>
      <add-edit-f-m :FMObj="FMObj" v-model="addEditShow2" @getFather="getFather"></add-edit-f-m>
    </el-dialog>
  </div>
</template>

<script>
import addEditListPhone from './addEditListPhone'
import addEditFM from './addEditFM'
import fmInfo from '../deviceComponents/fmInfo'
export default {
  name: 'deviceParam',
  components: {
    addEditListPhone,
    addEditFM,
    fmInfo
  },
  model: {
    prop: 'paramShow',
    event: 'change'
  },
  props: {
    paramObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '通讯录设置'},
        {index: 1, name: 'FM频率设置'}
      ],
      indexActive: 0,
      showTable1: [{name: ''}],
      addEditShow1: false,
      listObj: {},
      showTable2: [{name: ''}],
      addEditShow2: false,
      FMObj: {
        devicerow: '',
        fmRow: '',
        isAdd: true
      }
    }
  },
  created () {
    this.FMObj.devicerow = this.paramObj.devicerow
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    addOpen () {
      if (this.indexActive === 0) {
        this.addEditShow1 = true
      } else if (this.indexActive === 1) {
        this.addEditShow2 = true
      }
    },
    getFather () {
      this.$refs.fm.getFmInfo()
    }
  }
}
</script>

<style scoped>
  .select-active{
    padding: 0 15px;
    float: left;
    font-size: 16px;
    color: #1684FC;
    border-bottom: 1px solid;
  }
  .no-select{
    padding: 0 15px;
    float: left;
    font-size: 16px;
    color: #bbbbbb;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/deviceParam.vue